import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App"
import Parent from './parent';
import Color from "./colorApp"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {/* <App /> */}
    {/* <Parent/> */}
    <Color/>
  </>
);

